import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Link from 'redux-first-router-link'
import { debounce } from 'throttle-debounce'
import scenes from './scenes'
import { GOTO_BATTLE, GOTO_HOME, goToHome } from './redux/actions/routing/route.actions'
import './App.scss'

const App = ({ location }) => {
    const { type } = location
    const gameOuterDOMNode = useRef(null)
    const rootElement = document.documentElement

    function getWindowDimensions() {
        const { innerWidth: width, innerHeight: height } = window
        return {
            width,
            height,
        }
    }

    const [gameDimensions, setGameDimensions] = useState({ width: 0, height: 0 })

    useEffect(() => {
        function adjustScreen() {
            const gameOuter = gameOuterDOMNode.current
            gameOuter.className = 'game__outer adjusted'

            const ratioHeight = 1 / 1.78
            const ratioWidth = 1.78
            const { width: vw, height: vh } = getWindowDimensions()

            const width = (vw > vh)
                ? (vh * ratioWidth <= vw)
                    ? (vh * ratioWidth)
                    : (vw)
                : (vh * ratioHeight <= vw)
                    ? (vh * ratioHeight)
                    : (vw)

            const height = (vw > vh)
                ? (vw * ratioHeight <= vh)
                    ? (vw * ratioHeight)
                    : (vh)
                : (vw * ratioWidth <= vh)
                    ? (vw * ratioWidth)
                    : (vh)

            const longer = height > width ? height : width
            const fontSize = longer / 37.5

            setGameDimensions({ width, height })
            rootElement.style.fontSize = `${fontSize}px`
        }
        const debouncedResizeHandler = debounce(200, () => {
            adjustScreen()
        })
        adjustScreen()
        window.addEventListener('resize', debouncedResizeHandler)
        return () => window.removeEventListener('resize', debouncedResizeHandler)
    }, [rootElement.style.fontSize])

    const { width: gameWidth, height: gameHeight } = gameDimensions

    const { type: locationType } = location
    const hideButton = (
        locationType === GOTO_HOME
        || locationType === GOTO_BATTLE
    )

    const homeLink = hideButton
        ? ''
        : (
            <div className="TEMP_DEV_HOME_BUTTON">
                <Link className="buttonLink--wrapper" to={goToHome()}>
                    <button type="button">Home</button>
                </Link>
            </div>
        )

    return (
        <div className="game__outer" ref={gameOuterDOMNode} style={{ width: gameWidth, height: gameHeight }}>
            <div className="game__inner">
                {scenes[type]}
            </div>
            {homeLink}
        </div>
    )
}

App.propTypes = {
    location: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
    location: state.location,
})

export default connect(mapStateToProps)(App)
